export const recommendationTypes = {
  automatic: 'automatic',
  category: 'category',
  collection: 'collection',
}

export const recommendationOptions = [
  {
    label: 'Recomendaciones automáticas',
    value: recommendationTypes.automatic,
  },
  {
    label: 'Productos de una categoría',
    value: recommendationTypes.category,
  },
  {
    label: 'Productos de una colección',
    value: recommendationTypes.collection,
  },
]
